/**
 * Hook for label generation and printing
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
// @ts-ignore
import qz from 'qz-tray';
import { selectShipmentId, selectShipmentRouteSegments, selectUserPreferences } from '../../redux/packing';
import { usePrinterConnection } from './usePrinterConnection';
// Helper to check if QZ websocket is actually active
var isQzWebsocketActive = function () {
    return qz && qz.websocket && qz.websocket.isActive();
};
export var useLabelPrinting = function () {
    var shipmentId = useSelector(selectShipmentId);
    var shipmentRouteSegments = useSelector(selectShipmentRouteSegments);
    var userPreferences = useSelector(selectUserPreferences);
    var printLabel = usePrinterConnection().printLabel;
    // Generate label URL
    var getLabelUrl = useCallback(function (type, packageSeqId, containerId) {
        var baseUrl = process.env.REACT_APP_API_BASE_URL;
        switch (type) {
            case 'main':
                return baseUrl + "/fop/apps/PopcAdmin/Shipment/ShipmentAllLabel?shipmentId=" + shipmentId + "&shipmentPackageSeqId=" + packageSeqId;
            case 'return':
                return baseUrl + "/fop/apps/PopcAdmin/Shipment/ShipmentPackageReturnLabel?shipmentId=" + shipmentId + "&shipmentPackageSeqId=" + packageSeqId;
            case 'all':
                return baseUrl + "/fop/apps/PopcAdmin/Shipment/ShipmentAllLabel?shipmentId=" + shipmentId + (packageSeqId ? "&shipmentPackageSeqId=" + packageSeqId : '');
            case 'containerLabel':
                return baseUrl + "/fop/apps/PopcAdmin/Shipment/ShipmentContainerLicensePlate?shipmentId=" + shipmentId + (containerId ? "&containerId=" + containerId : '');
            case 'containerInsert':
                return baseUrl + "/fop/apps/PopcAdmin/Shipment/ShipmentContainerInsert?shipmentId=" + shipmentId + (packageSeqId ? "&shipmentPackageSeqId=" + packageSeqId : '');
            case 'packingSlip':
                return baseUrl + "/fop/apps/PopcAdmin/Shipping/ShipmentInsert?shipmentId=" + shipmentId + (packageSeqId ? "&shipmentPackageSeqId=" + packageSeqId : '');
            default:
                return '';
        }
    }, [shipmentId]);
    // Download label
    var downloadLabel = useCallback(function (url) {
        var moquiSessionToken = localStorage.getItem('moquiSessionToken');
        var downloadUrl = url + "&moquiSessionToken=" + moquiSessionToken;
        // Create a link element and trigger download
        var link = document.createElement('a');
        link.href = downloadUrl;
        link.target = '_blank';
        link.download = '';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }, []);
    // Print main label
    var printMainLabel = useCallback(function (shipmentPackageSeqId) { return __awaiter(void 0, void 0, void 0, function () {
        var labelUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    labelUrl = getLabelUrl('main', shipmentPackageSeqId);
                    if (!(isQzWebsocketActive() && userPreferences['qz.printer.main.active'])) return [3 /*break*/, 2];
                    return [4 /*yield*/, printLabel(labelUrl, 'main')];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    // Fallback to download
                    downloadLabel(labelUrl);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [shipmentId, getLabelUrl, userPreferences, printLabel, downloadLabel]);
    // Print return label
    var printReturnLabel = useCallback(function (shipmentPackageSeqId) { return __awaiter(void 0, void 0, void 0, function () {
        var shipmentRouteSegmentSeqId, labelUrl;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    shipmentRouteSegmentSeqId = (_a = shipmentRouteSegments === null || shipmentRouteSegments === void 0 ? void 0 : shipmentRouteSegments[0]) === null || _a === void 0 ? void 0 : _a.shipmentRouteSegmentSeqId;
                    labelUrl = process.env.REACT_APP_API_BASE_URL + "/rest/s1/handheld/pack/shipment/" + shipmentId + "/label?shipmentRouteSegmentSeqId=" + shipmentRouteSegmentSeqId + "&shipmentPackageSeqId=" + shipmentPackageSeqId + "&retLabel=true";
                    if (!(isQzWebsocketActive() && userPreferences['qz.printer.main.active'])) return [3 /*break*/, 2];
                    return [4 /*yield*/, printLabel(labelUrl, 'main')];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    downloadLabel(labelUrl);
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [shipmentId, shipmentRouteSegments, userPreferences, printLabel, downloadLabel]);
    // Print all labels
    var printAllLabels = useCallback(function (shipmentPackageSeqId) { return __awaiter(void 0, void 0, void 0, function () {
        var labelUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    labelUrl = getLabelUrl('all', shipmentPackageSeqId);
                    if (!(isQzWebsocketActive() && userPreferences['qz.printer.main.active'])) return [3 /*break*/, 2];
                    return [4 /*yield*/, printLabel(labelUrl, 'main')];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    downloadLabel(labelUrl);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [shipmentId, getLabelUrl, userPreferences, printLabel, downloadLabel]);
    // Print packing slip
    var printPackingSlip = useCallback(function (shipmentPackageSeqId) { return __awaiter(void 0, void 0, void 0, function () {
        var labelUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    labelUrl = getLabelUrl('packingSlip', shipmentPackageSeqId);
                    if (!(isQzWebsocketActive() && userPreferences['qz.printer.main.active'])) return [3 /*break*/, 2];
                    return [4 /*yield*/, printLabel(labelUrl, 'main')];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    downloadLabel(labelUrl);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [shipmentId, getLabelUrl, userPreferences, printLabel, downloadLabel]);
    // Print container insert
    var printContainerInsert = useCallback(function (shipmentPackageSeqId) { return __awaiter(void 0, void 0, void 0, function () {
        var labelUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    labelUrl = getLabelUrl('containerInsert', shipmentPackageSeqId);
                    if (!(isQzWebsocketActive() && userPreferences['qz.printer.main.active'])) return [3 /*break*/, 2];
                    return [4 /*yield*/, printLabel(labelUrl, 'main')];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    downloadLabel(labelUrl);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [shipmentId, getLabelUrl, userPreferences, printLabel, downloadLabel]);
    /**
     * SPS LABEL
     */
    var printCartonLabel = useCallback(function (productStoreId) { return __awaiter(void 0, void 0, void 0, function () {
        var moquiSessionToken, response, responseData, url, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    moquiSessionToken = localStorage.getItem('moquiSessionToken');
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/pack/shipment/" + shipmentId + "/spsCartonLabel?shipmentId=" + shipmentId + "&productStoreId=" + productStoreId, { headers: { moquiSessionToken: moquiSessionToken || '' } })];
                case 2:
                    response = _a.sent();
                    responseData = response.data;
                    if (!(response.status === 200 && (responseData === null || responseData === void 0 ? void 0 : responseData.shipmentContentId))) return [3 /*break*/, 5];
                    url = process.env.REACT_APP_API_BASE_URL + "/apps/oms/Shipment/ShipmentDetail/downloadContent?shipmentId=" + shipmentId + "&shipmentContentId=" + responseData.shipmentContentId;
                    if (!(isQzWebsocketActive() && userPreferences['qz.printer.label.active'])) return [3 /*break*/, 4];
                    return [4 /*yield*/, printLabel(url, 'label')];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    downloadLabel(url);
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    error_1 = _a.sent();
                    console.error('Error printing carton label:', error_1);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); }, [shipmentId, userPreferences, printLabel, downloadLabel]);
    var printContainerLabel = useCallback(function (containerId) { return __awaiter(void 0, void 0, void 0, function () {
        var labelUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    labelUrl = getLabelUrl('containerLabel', undefined, containerId);
                    if (!(isQzWebsocketActive() && userPreferences['qz.printer.label.active'])) return [3 /*break*/, 2];
                    return [4 /*yield*/, printLabel(labelUrl, 'label')];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    downloadLabel(labelUrl);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [shipmentId, getLabelUrl, userPreferences, printLabel, downloadLabel]);
    return {
        printMainLabel: printMainLabel,
        printReturnLabel: printReturnLabel,
        printAllLabels: printAllLabels,
        printPackingSlip: printPackingSlip,
        printContainerInsert: printContainerInsert,
        printCartonLabel: printCartonLabel,
        printContainerLabel: printContainerLabel,
        downloadLabel: downloadLabel,
        getLabelUrl: getLabelUrl
    };
};
export default useLabelPrinting;
